import DateParser from '../../DateParser';
import NumberFormatter from '../../NumberFormatter';

export default class AmortizationScheduleTable {

    constructor(legacyResponse) {

        if (legacyResponse != undefined) {

            const { columns, years } =
                AmortizationScheduleTable.generateTableDataFromLegacy(legacyResponse.report.table);
    
            this.legacyTable = legacyResponse.report.table;
            this.earlyPayments = legacyResponse.report.earlyPayments;
            this.columns = columns;
            this.years = years;
        }
        else {

            this.legacyTable = {};
            this.columns = {};
            this.years = {};
            this.earlyPayments = [];
        }
    }

    getEarlyPayments() {

        return this.earlyPayments;
    }

    getRows() {

        if (this.rows == undefined) {

            this.rows = [];
            Object.values(this.years).forEach((year) => {

                year.rows.forEach((row) => this.rows.push(row));
            });
        }

        return this.rows;
    }

    getFirstPaymentDate() {

        return this.getRows()[0].paymentDate;
    }

    getLastPaymentDate() {

        const rows = this.getRows();
        return rows[ rows.length - 1 ].paymentDate;
    }
    
    static getColumnsMapping() {

        return {
            paymentId: 'pay_number',
            paymentDate: 'pay_date',
            balance: 'incoming_balance',
            endingBalance: 'outgoing_balance',
            payment: 'pay_all',
            paymentWithoutPercent: 'pay_debt',
            paymentPercent: 'pay_percent',
            earlyPayment: 'pay_early',
        };
    }

    static getColumnsMappingIds(table) {

        const mapping = AmortizationScheduleTable.getColumnsMapping();
        
        return Object.fromEntries(Object
            .entries(mapping)
            .map(([name, key]) => {

                return [name, table.columns.indexOf(key)];
            }))
    }
    
    static generateTableDataFromLegacy(legacyTable) {

        const
            mapping = AmortizationScheduleTable.getColumnsMappingIds(legacyTable),
            columns = {},
            years = {};

        if (legacyTable.head != undefined) {

            // generate columns

            legacyTable.head
                .forEach((title, index) => {

                    columns[Object.keys(mapping).find((key) => mapping[key] === index)] = title;
                });
        }

        if (legacyTable.body != undefined) {

            // generate years and inner rows

            legacyTable.body.forEach((row) => {
                
                const

                    year = DateParser.fromString(row[mapping['paymentDate']]).getFullYear(),

                    normalizedRow = {
                        id: row[mapping['paymentId']],
                        paymentDate: DateParser.fromString(row[mapping['paymentDate']]),
                        payment: NumberFormatter.parse(row[mapping['payment']]),
                        paymentPercent: NumberFormatter.parse(row[mapping['paymentPercent']]),
                        paymentWithoutPercent: NumberFormatter.parse(row[mapping['paymentWithoutPercent']]),
                        endingBalance: NumberFormatter.parse(row[mapping['endingBalance']]),
                        earlyPayment: NumberFormatter.parse(row[mapping['earlyPayment']]),
                    };

                if (normalizedRow.id) {
                    
                    // skip empty rows

                    if (years[year] == undefined) {

                        years[year] = {
                            id: year,
                            title: year.toString(),
                            details: {
                                payment: normalizedRow.payment.clone(),
                                paymentPercent: normalizedRow.paymentPercent.clone(),
                                paymentWithoutPercent: normalizedRow.paymentWithoutPercent.clone(),
                                endingBalance: normalizedRow.endingBalance.clone(),
                            },
                            rows: [ normalizedRow ],
                        };
                    }
                    else {

                        years[year].details.payment.plus(normalizedRow.payment);
                        years[year].details.paymentPercent.plus(normalizedRow.paymentPercent);
                        years[year].details.paymentWithoutPercent.plus(normalizedRow.paymentWithoutPercent);
                        years[year].details.endingBalance = normalizedRow.endingBalance;
                        years[year].rows.push(normalizedRow);
                    }
                }

            });

        }

        return { columns, years };
    }
}